import { DOMAINS, SOURCE_LANGS } from "../../utils/Constant";

// src/components/dictionary/DictionarySearchForm.jsx
export default function DictionarySearchForm({
  searchText,
  setSearchText,
  sourceLang,
  setSourceLang,
  targetLang,
  setTargetLang,
  domain,
  setDomain,
  onSearch,
}) {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!searchText.trim()) return;
    onSearch({
      text: searchText,
      sourceLang,
      targetLang,
      domain,
    });
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-3 md:gap-4 mb-8"
    >
      {/* Search input — takes ~1/3 width on lg+ screens (4/12 columns) */}
      <div className="lg:col-span-4">
        <input
          type="text"
          placeholder="Search word or phrase..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="w-full px-4 py-2.5 text-base border border-gray-300 rounded-lg 
                     shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                     outline-none transition-all duration-150"
        />
      </div>

      {/* Source Language */}
      <div className="lg:col-span-2">
        <select
          value={sourceLang}
          onChange={(e) => setSourceLang(e.target.value)}
          className="w-full px-3 py-2.5 text-base bg-white border border-gray-300 rounded-lg 
                     shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                     outline-none appearance-none transition-all duration-150"
        >
          <option value="">From</option>
          {SOURCE_LANGS.map((lang) => (
            <option key={lang.value} value={lang.value}>
              {lang.label}
            </option>
          ))}
        </select>
      </div>

      {/* Target Language */}
      <div className="lg:col-span-2">
        <select
          value={targetLang}
          onChange={(e) => setTargetLang(e.target.value)}
          className="w-full px-3 py-2.5 text-base bg-white border border-gray-300 rounded-lg 
                     shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                     outline-none appearance-none transition-all duration-150"
        >
          <option value="">To</option>
          {SOURCE_LANGS.map((lang) => (
            <option key={lang.value} value={lang.value}>
              {lang.label}
            </option>
          ))}
        </select>
      </div>

      {/* Domain */}
      <div className="lg:col-span-2">
        <select
          value={domain}
          onChange={(e) => setDomain(e.target.value)}
          className="w-full px-3 py-2.5 text-base bg-white border border-gray-300 rounded-lg 
                     shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                     outline-none appearance-none transition-all duration-150"
        >
          <option value="">Domain</option>
          {DOMAINS.map((d) => (
              <option key={d.value} value={d.value}>
                {d.label}
              </option>
            ))}
        </select>
      </div>

      {/* Submit Button */}
      <div className="lg:col-span-2 flex items-end">
        <button
          type="submit"
          disabled={!searchText.trim()}
          className="w-full bg-blue-600 hover:bg-blue-700 active:bg-blue-800 
                     text-white font-medium py-2.5 px-6 rounded-lg 
                     shadow-sm transition-all duration-150 disabled:opacity-50 
                     disabled:cursor-not-allowed"
        >
          Search
        </button>
      </div>
    </form>
  );
}